import { render, staticRenderFns } from "./warehousePankuiManagement.vue?vue&type=template&id=4a0aa4d4&scoped=true&"
import script from "./warehousePankuiManagement.vue?vue&type=script&lang=js&"
export * from "./warehousePankuiManagement.vue?vue&type=script&lang=js&"
import style0 from "./warehousePankuiManagement.vue?vue&type=style&index=0&id=4a0aa4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0aa4d4",
  null
  
)

export default component.exports